module.exports = __webpack_public_path__ + "img/building-icon.a8afa763.svg";